import {TypedUseSelectorHook, useSelector} from 'react-redux';
import {RootState} from '../rootReducer';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// For performance tracking, use:
/*
export const useAppSelector: TypedUseSelectorHook<RootState> = (selector, equalityFn) => {
  return useSelector(withPerformanceTracking(selector), equalityFn);
};
*/
